import { BASE_API_URL } from '@env';
import { useMutation, useQueryClient } from 'react-query';
import { useUserStore } from '~providers/userStore/zustand';
import { UpdateUserStatus } from '~types/api/event';

const useUpdateUserStatus = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, Error, UpdateUserStatus>(
    async (requestData: UpdateUserStatus) => {
      const token = useUserStore.getState().token;
      const endPoint = requestData.user_id
        ? `${BASE_API_URL}events/${requestData.event_id}/subscriptions/${requestData.user_id}`
        : `${BASE_API_URL}events/${requestData.event_id}/external/subscriptions/${requestData.email}`;
      const response = await fetch(endPoint, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to update user status');
      }

      const data = await response.json();

      return data;
    },
    {
      onSuccess: async () => {
        await queryClient.refetchQueries('eventAttendees');
        await queryClient.refetchQueries('eventPending');
      },
    },
  );
};

export default useUpdateUserStatus;
